import { Component, OnInit } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';

import { CerPromptService, PromptFormOptions, PromptInput } from '@ui/cer-ui-prompt.service';

import { CerMetaUserView } from '@form/cer-form-persistence.service';
import { CerAppRouteService } from '../../cer-app-route/cer-app-route.service';
import { CerSessionService } from 'src/cer/cer-session/cer-session.service';

import { ProgressDto } from 'src/app/api';
import { CerUserRoute } from '@cer/cer-session/cer-session-user-navigation.service';
import { CerFormDataNavigation } from '@cer/cer-form/cer-form-navigation.service';

export class ViewMenuItem {
  public icon: string;
  public name?: string;
  public text: string;
  public isPrimary: boolean;
  public isSelected: boolean;
  public type: 'standard' | 'design' | 'complete' | 'custom' | 'edit' | 'add' | 'update';
  public separator?: boolean;
  public trackId: number;
}

@Component({
  selector: 'cer-app-layout-route-title',
  templateUrl: './cer-app-layout-route-title.component.html',
  styleUrls: ['./cer-app-layout-route-title.component.css']
})
export class CerAppLayoutRouteTitleComponent implements OnInit {
  private subscriptionManager$: Subscription = new Subscription();

  public title: string;
  //public activeViewPersistenceService: ICerViewPersistenceService;
  protected pageIsLoading: boolean = false;
  protected progressHidden: boolean = true;
  protected progressText: string = "";
  protected progressValue: number = 0;
  protected progressValueMax: number = 0;
  protected progressBarClasses: string;
  protected progressValueIndicator: string = "";
  protected progressValueStyle: string = "";

  //public viewNameTitle$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public pageTitleViewMenu: ViewMenuItem[];

  private userRoute: CerUserRoute;
  public selectedView: CerMetaUserView = null;
  public selectedViewMenuItem: ViewMenuItem;
  public viewMenuItems: ViewMenuItem[];
  public primaryMenuItems: ViewMenuItem[] = [];
  private trackId: number = 0;
  protected personalizeActive: boolean = false;

  constructor(
    private routeService: CerAppRouteService,
    private sessionService: CerSessionService,
    private ui: CerPromptService) {

    this.subscriptionManager$.add(
      this.routeService.isLoading$.subscribe(pageIsLoading => {
        this.pageIsLoading = pageIsLoading;
        this.progressUpdate(pageIsLoading);
      })
    );

    this.subscriptionManager$.add(
      combineLatest([
        this.routeService.activeViewPersistenceService$,
        this.routeService.routeDataInfo$
      ]).subscribe(([persistenceSvc, routeDataInfo]) => {
        this.title = routeDataInfo?.title;
        //this.activeViewPersistenceService = persistenceSvc;
        const personalizeActive = (persistenceSvc != null && routeDataInfo != null && routeDataInfo.personizationDisabled != true);
        if (personalizeActive && !this.personalizeActive)
        {
          this.personalizeActive = personalizeActive;
          this.onUserRouteActivated();
        }
        else {
          this.personalizeActive = personalizeActive;
        }
      })
    );

    this.subscriptionManager$.add(
      this.routeService.activeUserRoute$.subscribe(userRoute => {
        this.userRoute = userRoute;
        if (userRoute) {
          this.onUserRouteActivated();
        }
      })
    );

    this.subscriptionManager$.add(
      this.routeService.activeView$.subscribe(view => {
        if (view) {
          this.onActiveViewActivated(view);
        }
      })
    );

    /*
    this.subscriptionManager$.add(
      this.routeService.routeData$.subscribe(routeData => {
        if (routeData) {
          this.routeData = routeData;
        }
      })
    );
    */

    this.subscriptionManager$.add(
      this.sessionService.progress$.subscribe(progress => {
        this.progressUpdate(this.pageIsLoading, progress);
      }));
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.subscriptionManager$.unsubscribe();
  }

  private progressUpdate(pageIsLoading: boolean, progress: ProgressDto = null) {
    this.progressHidden = !pageIsLoading;
    this.progressText = progress?.text ?? "";
    var hasCount = progress?.count != null;
    var hasTotal: boolean = (progress?.total > 0);
    var hasPct: boolean = hasTotal && hasCount;
    var value: number = hasPct ? Math.floor(progress.count / progress.total * 100) : hasCount ? progress.count : 0;
    this.progressValueIndicator = hasPct ? "%" : "";
    this.progressValue = value;
    this.progressValueMax = hasPct ? 100 : 0;
    this.progressValueStyle = hasCount ? "--value: " + value.toString() + "; --pctIndicator: '" + this.progressValueIndicator + "';" : "";
    this.progressBarClasses = "progressbar " + (hasPct ? "progressbar-pct" : "progressbar-auto" + (hasCount ? " progressbar-count" : ""));
  }

  private onUserRouteActivated() {
    this.uiRefresh();
  }

  public onActiveViewActivated(view: CerMetaUserView) {
    this.selectedView = view;
    this.uiRefresh();
  }

  private uiRefresh() {
    this.menuItemsRefresh();
    this.menuPrimaryRefresh();
  }

  private menuItemsRefresh() {
    var menuItems: ViewMenuItem[] = [];
    if (this.userRoute?.views) {
      this.userRoute.views.forEach(view => menuItems.push(
        {
          text: view.name, name: view.name,
          icon: view.type == 'standard' ? 'view_column' : view.type == 'complete' ? 'view_comfy' : (view.type == 'design' ? 'information-outline' : 'bookmark'),
          type: view.type,
          isPrimary: ((view.type == 'custom' || view.type == 'design') && view.isPrimary),
          isSelected: false,
          trackId: this.trackId
        })
      );

      var hasCustomView = (menuItems.filter(view => view.type == 'custom').length);
      var selectedCustomViewName: string = (this.selectedView?.type == 'custom') ? this.selectedView.name : null;

      if (hasCustomView) {
        menuItems.push({ text: 'Vedligehold', icon: 'build', type: 'edit', isPrimary: false, isSelected: false, trackId: this.trackId, separator: true });
      }
      menuItems.push({ text: 'Opret ny', icon: 'add', type: 'add', isPrimary: false, isSelected: false, trackId: this.trackId, separator: !hasCustomView });
      if (selectedCustomViewName?.length > 0) {
        menuItems.push({ text: 'Opdater "' + selectedCustomViewName + '"', icon: 'save_alt', type: 'update', isPrimary: false, isSelected: false, trackId: this.trackId });
      }
    }
    this.viewMenuItems = menuItems;
  }


  private menuPrimaryRefresh() {
    this.trackId++;
    var view = this.selectedView;
    var items = this.viewMenuItems.filter(mi => ((mi.isPrimary || mi.type == 'design') || (view?.name?.length > 0 && mi.name == view?.name && mi.type != 'standard')));
    items.forEach(mi => {
      mi.trackId = this.trackId;
      mi.isSelected = (mi.name?.length > 0 && view?.name?.length > 0 && view?.name == mi.name);
      if (mi.isSelected) {
        this.selectedViewMenuItem = mi;
      }
    });
    this.primaryMenuItems = items;
  }

  private selectViewName(name: string) {
    var view: CerMetaUserView = this.userRoute?.views?.find(i => i.name == name);
    if (view) {
      this.routeService.userViewSelect(view);
    }
  }

  public trackViewMenuItem(index: number, item: ViewMenuItem) {
    return item.trackId;
  }

  protected clickedViewMenu(mi: ViewMenuItem) {
    switch (mi.type) {
      case 'edit':
        this.userViewsManage();
        break;
      case 'add':
        this.userViewDialogSave();
        break;
      case 'update':
        this.userViewUpdate();
        break;
      default:
        this.selectViewName(mi.name);
    }
  }

  public reloadUrl() {
    this.routeService.reloadUrl();
  }

  public userViewsManage() {
    const currentUrl = this.routeService.routeDataInfo$?.getValue()?.url;
    const url = 'user/route-view';
    const dataNavigation: CerFormDataNavigation = {
      url: url,
      title: 'Visninger',
      route: this.routeService.routeGetByUrl(url),
      paneTarget: 'main',
      parentView: null,
      mode: 'list',
      link: 'nav',
      mandatory: true, // avoid tabs visible
      callerData: {
        url: currentUrl
      }
    };
    const persistenceSvcSave =  this.routeService.activeViewPersistenceService$.getValue();
    this.ui.showDataNavigationAsDialog(dataNavigation)
      .then(
        diaglogResult => {
          const url = this.routeService.currentUrl;
          if (url.length > 0) {
            this.sessionService.userNavigation.apiUserRouteGet(url).then(userRoute => {
              this.routeService.setIsLoading(false);
              this.routeService.activeViewPersistenceService$.next(persistenceSvcSave);
              this.routeService.userRouteViewSelect(userRoute);
            })
          }
        }
      ).catch(
        error => {
          window.alert("Error: " + error);
          this.routeService.setIsLoading(false);
        }
      );
  }

  public userViewUpdate() {
    var view = this.routeService.activeView$.getValue();
    if (view?.type == 'custom') {
      this.userViewDialogSave(view.name, view.isPrimary, view.isDefault);
    }
  }

  private userViewDialogSave(viewNameOrig: string = '', isPrimary: boolean = true, isDefault: boolean = false) {
    var nameId = 'name';
    var isDefaultId = 'isDefault';
    var isPrimaryId = 'isPrimary';
    var inputs: PromptInput[] = [
      { label: 'Visningsnavn', id: nameId, placeholder: 'Angiv visningsnavn', value: viewNameOrig, element: null },
      { label: 'Er primær?', id: isPrimaryId, placeholder: 'Skal visning være primær og vises som primære valgmulighed', valueNumber: isPrimary ? 1 : 0, element: null, type: 'CheckBox' },
      { label: 'Valgt ved opstart?', id: isDefaultId, placeholder: 'Skal visning vælges ved opstart', valueNumber: isDefault ? 1 : 0, element: null, type: 'CheckBox' }
    ];
    this.ui.promptInputs('', 'Gem visning', inputs).then(
      result => {
        if (result.action == 'ok') {
          const viewName = <string>result.inputs.find(i => i.id == nameId).value;
          isPrimary = result.inputs.find(i => i.id == isPrimaryId).valueNumber == 1;
          isDefault = result.inputs.find(i => i.id == isDefaultId).valueNumber == 1;
          if (viewName?.length > 0) {
            this.routeService.userViewCustomSave(viewName, isPrimary, isDefault, viewNameOrig);
          }
        }
      }
    );
  }
}
